import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-white p-3 m-2 me-1",
  style: {"width":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "pb-2" }, "Dla jakiej stawki dokonać obliczeń?", -1)
const _hoisted_3 = { class: "p-0 m-0 me-0" }
const _hoisted_4 = { class: "form-floating" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "floatingInputValue" }, "Cena za 1kWh (w groszach):", -1)
const _hoisted_6 = { class: "form-floating" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "floatingInputValueHeat" }, "Cena za GJ ciepła (w PLN):", -1)

import { useStore } from "vuex";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'stawkaPradu',
  setup(__props) {

const store = useStore();

const globalPowerCost = computed<number>({
  get: () => store.getters["miners/getGlobalPowerCost"],
  set: (value: number) => {
    store.commit("miners/setGlobalPowerCost", value);
    store.commit("miners/setMinersProfits");
  },
});
const globalHeatPrice = computed<number>({
  get: () => store.getters["miners/getGlobalHeatPrice"],
  set: (value: number) => {
    store.commit("miners/setGlobalHeatPrice", value);
    store.commit("miners/setMinersProfits");
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "number",
          class: "form-control",
          id: "floatingInputValue",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((globalPowerCost).value = $event))
        }, null, 512), [
          [
            _vModelText,
            globalPowerCost.value,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "number",
          class: "form-control",
          id: "floatingInputValueHeat",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((globalHeatPrice).value = $event))
        }, null, 512), [
          [
            _vModelText,
            globalHeatPrice.value,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_7
      ])
    ])
  ]))
}
}

})